import axios from 'axios';
import Button from 'blocks/Button';
import Breadcrumb from 'components/Breadcrumb';
import { RadioButton } from 'components/Form';
import Paths from 'helper/paths';
import { useQueryParams } from 'hooks/useQueryParams';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import urls from 'utils/urls';
import FlightForm from './components/flightForm/index';
import * as S from './form.styles';

const DiscountPage = () => {
  const query = useQueryParams();
  const [discountType, setDiscountType] = useState<any>([]);
  const [activeDiscountType, setActiveDiscountType] = useState<any>(query.get('discountTicketId') || 1);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const breadcrumbLinks = [
    {
      title: t(`pageTitles.${Paths.Dashboard.index().name}`),
      url: Paths.Dashboard.index().route,
      active: true,
    },
    {
      title: t(`pageTitles.${Paths.Services.discount().name}`),
      url: '',
      active: false,
    },
  ] as BreadcrumbInterface[];

  useEffect(() => {
    getDiscountType();
  }, [query]);
  const goToSearch = async () => {
    navigate(Paths.Services.showHistoryDiscount().route);
  };

  const getDiscountType = async () => {
    const res = await axios.get(urls.discountType);
    const typeUser = res.data.response.discountTickets.map((d) => {
      return {
        title: d.name.split('-')[0],
        value: d.id.toString(),
        checked: false,
      };
    });

    setDiscountType(typeUser);

    setActiveDiscountType(query.get('discountTicketId') || typeUser[0].value);
  };
  return (
    <WithSidebar>
      <S.containerTitleAndBtnFreeTicket>
        <Breadcrumb links={breadcrumbLinks} title={t('pages.services.discount.pages.form.title')} />
        <Button styleType="default" className=" fs-xs" onClick={goToSearch}>
          {t('pages.services.discount.pages.form.btn')}
        </Button>
      </S.containerTitleAndBtnFreeTicket>
      {discountType.length == 0 ? (
        <S.Wrapper>{t('pages.services.discount.pages.form.notDiscount')}</S.Wrapper>
      ) : (
        <S.Wrapper>
          <S.FlightTypesWrapper>
            <RadioButton
              items={discountType}
              defaultValue={(query.get('discountTicketId') || discountType[0].value) + ''}
              onChange={(value) => {
                setActiveDiscountType(value);
              }}
            />
          </S.FlightTypesWrapper>
          <FlightForm discountType={activeDiscountType} />
        </S.Wrapper>
      )}
    </WithSidebar>
  );
};

export default DiscountPage;
